module.exports = __webpack_public_path__ + "static/media/react.10c64990.png";